module.exports = __webpack_public_path__ + "img/krokodil_gefahrgut_vektorisiert.71fcac5.svg";